import React from "react";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next/hooks";
// import Img from "react-cool-img";


// import Button from "../../../Button/Button";
import Loader from "../../Loader/Loader";

// import TalkQRScan from "./TalkQRScan";

import { useStore } from "../../../hook-store/store";
import { makeQrcode } from "../../../util/image";

import { marks } from "../../../images/marks";
// import SampleImage from "../../../Image/person-icon-50.jpg";

import { SOCKET_GROUP_URL } from "../../../App";

import './GroupInvitation.css';
// import classes from "./TaklUserListControlQRCode.module.css";

const GroupInvitationQRCode = (props) => {
  // console.log("TalkUserListControllContents.js-props", props);

  const {
    group,
    // isLoading,
  } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  // console.log('store-TalkUserListControlQRcode', store);
  // const talkPermission = store.talkPermission;

  const [createdQR, setCreatedQR] = useState();
  const [showQRCode, setShowQRCode] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  // const [startScan, setStartScan] = useState(false);

  useEffect(() => {
    const makeQRHandler = async () => {
      try {
        setIsLoading(true);

        const tokenForQR = await createTokenForInviteQR(
          SOCKET_GROUP_URL, 
          localStorage.getItem('token'),
          group.groupRoomId,
        ); 

        console.log('tokenForQR', tokenForQR);

        // const generatedQR = await makeQrcode(JSON.stringify({
        //   userId: localStorage.getItem('userId'),
        //   token: localStorage.getItem('token'),
        // }));

        if (tokenForQR) {
          const generatedQR = await makeQrcode(JSON.stringify({
            token: tokenForQR.data,
            qrType: 'invitation',
            // userId: localStorage.getItem('userId'),
          }));
          // const generatedQR = await makeQrcode(localStorage.getItem('token'));
  
          if (generatedQR) {
            setCreatedQR(generatedQR);
          }
        }

        setIsLoading(false);

      } catch(err) {
        console.log(err);
        setIsLoading(false);
      }
    };

    if (showQRCode) {
      makeQRHandler();
    }

  },[showQRCode]);


  const createTokenForInviteQR = async (url, token, groupRoomId) => {
    try {
      const result = await fetch(url + '/group-invitation/create-token-for-group-invite-qr', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          groupRoomId: groupRoomId,
        }),
      });
  
      const resData = await result.json();

      console.log(result, resData);
      // dispatch('SET_TALKPERMISSION', resData.data);

      if (!result.ok) {
        throw new Error('error occured');
      }

      if (resData.data) {
        return resData;
      }
    } catch(err) {
      console.log(err);
      throw err;
    }
  };

  let talkUserListControlQRcodeBody;

  talkUserListControlQRcodeBody = (
    <div 
    // className={classes.talkUserListQR}
    >
      <div className='groupInvitationRow'
        onClick={() => {
          setShowQRCode(!showQRCode);
        }}
      > 
        {t("videoTalk.text29", "Display QR Code")}
        {' '}
        {marks.qrcode}
        {' '}
        {marks.triangleDown}
      </div>
      {showQRCode && (
        <div className='groupInvitationRow'>
          {t('groupTalk.text96', 'User who scanned this QR code will be accepted to join this group.')}
          <br/>
          {t('groupTalk.text100', 'QR code scanner exist at settings in this page.')}
          <br/>
          {t('groupTalk.text97', 'This QR code is valid for 1 hour.')}
          <br/>
          <img 
            style={{height: "160px"}}
            src={createdQR}
          />
        </div>
      )}
    </div>
  )

  return <Fragment>
      {isLoading && <Loader />}
      {talkUserListControlQRcodeBody}
    </Fragment>;
};

export default GroupInvitationQRCode;
